var _line, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStatistics = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e024a8cc-ba6a-4445-b6ca-d37c23f7a5eb",
    width: 20,
    path: 20,
    fill: "#fff",
    "data-name": "Capa 1",
    viewBox: "0 0 44.99 43.25",
    ref: svgRef
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.21,
    y1: 42,
    x2: 43.78,
    y2: 42
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21,43.25H43.78a1.25,1.25,0,0,0,0-2.5H1.21a1.25,1.25,0,0,0,0,2.5Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.89,31H4.39a1.26,1.26,0,0,0-1.25,1.25V42a1.26,1.26,0,0,0,1.25,1.25h7.5A1.26,1.26,0,0,0,13.14,42V32.27a1.25,1.25,0,0,0-2.5,0V42l1.25-1.25H4.39L5.64,42V32.27L4.39,33.52h7.5A1.25,1.25,0,0,0,11.89,31Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.74,23.79h7.51L25,22.54V42l1.25-1.25H18.74L20,42V22.54a1.25,1.25,0,0,0-2.5,0V42a1.26,1.26,0,0,0,1.25,1.25h7.51A1.27,1.27,0,0,0,27.5,42V22.54a1.27,1.27,0,0,0-1.25-1.25H18.74A1.25,1.25,0,0,0,18.74,23.79Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.63,12.54h7.51l-1.25-1.25V42l1.25-1.25H33.63L34.88,42V11.29a1.25,1.25,0,0,0-2.5,0V42a1.26,1.26,0,0,0,1.25,1.25h7.51A1.27,1.27,0,0,0,42.39,42V11.29A1.27,1.27,0,0,0,41.14,10H33.63A1.25,1.25,0,0,0,33.63,12.54Z",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66,2.5h5.48L37.26.37l-7.78,7h1.76L26.47,2.64a1.28,1.28,0,0,0-1.77,0L8.32,17.11,6,19.19C4.75,20.26,6.52,22,7.73,21L24.11,6.49l2.36-2.08H24.7l4.78,4.72a1.26,1.26,0,0,0,1.76,0l7.79-7A1.26,1.26,0,0,0,38.14,0H32.66a1.25,1.25,0,0,0,0,2.5Z",
    transform: "translate(0 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.39,5.79V1.25A1.26,1.26,0,0,0,38.14,0a1.28,1.28,0,0,0-1.25,1.25V5.79a1.25,1.25,0,0,0,2.5,0Z",
    transform: "translate(0 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56,23.43a1.25,1.25,0,0,0,0-2.5,1.25,1.25,0,0,0,0,2.5Z",
    transform: "translate(0 0)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStatistics, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/statistics.805a6255.svg";
export { ForwardRef as ReactComponent };